module.exports = __webpack_public_path__ + "img/linkedin.35129832.svg";